import { Injectable } from '@angular/core';
import { BffCommunicationService } from '../../core/services/_index';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../app-config.service';
import { ProprieteModele } from '../modeles/proprieteModel';

@Injectable({
  providedIn: 'root'
})
export class ProprieteApiService {
  constructor(
    private readonly _bffCommunicationService: BffCommunicationService,
    private readonly _appConfigService: AppConfigService
  ) {}

  private getApiUrl() {
    const idProjet = this._appConfigService.idProjet;
    return `/api/v1/projets/${idProjet}/proprietes`;
  }

  getProprietes(): Observable<ProprieteModele[]> {
    return this._bffCommunicationService.getJSONBFF(this.getApiUrl()) as Observable<ProprieteModele[]>;
  }

  getPropriete(proprieteId: string): Observable<any> {
    return this._bffCommunicationService.getJSONBFF(`${this.getApiUrl()}/${proprieteId}`);
  }

  postPropriete(propriete: ProprieteModele): Observable<any> {
    return this._bffCommunicationService.postJSONBFF(`${this.getApiUrl()}/`, JSON.stringify(propriete));
  }

  deletePropriete(proprieteId: string): Observable<any> {
    return this._bffCommunicationService.deleteBFF(`${this.getApiUrl()}/${proprieteId}`);
  }

  updatePropriete(propriete: ProprieteModele): Observable<any> {
    return this._bffCommunicationService.putJSONBFF(`${this.getApiUrl()}/${propriete.id}`, propriete);
  }
}
